module.exports = __webpack_public_path__ + "img/Hand_31_05_09.c02cdb1b.png";